import React, {useState, useEffect, useCallback} from 'react';
import {ScrollTopButton} from './scroll-to-top.style'
import { FaLongArrowAltUp } from 'react-icons/fa'

const ScrollToTop = (props) => {
    const [stick, setStick] = useState(false);

    const onClickHandler = useCallback(() => {
      if (typeof window !== "undefined") {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    }, []);

    useEffect(() => {
      if (typeof window === "undefined") return;

      let position = window.pageYOffset;

      const scrollHandler = () => {
        const scrollPos = window.pageYOffset;
        if (scrollPos < 200) {
          setStick(false);
        } else if (scrollPos < position) {
          setStick(true);
        } else {
          setStick(false);
        }
        position = scrollPos;
      };

      window.addEventListener('scroll', scrollHandler);
      return () => {
        window.removeEventListener('scroll', scrollHandler);
      };
    }, []);

    
    
    return (
        <ScrollTopButton type="button" onClick={onClickHandler} isStick={stick} {...props}>
          <span className="icon arrow-up"><FaLongArrowAltUp /></span>
          <span className="icon arrow-bottom"><FaLongArrowAltUp /></span>
        </ScrollTopButton>
    )
}

export default ScrollToTop
